module.exports = __webpack_public_path__ + "static/media/windows_xp_deprecated.878ad061.png";